<template>
  <validation-observer
    v-if="stepData.employmentStatus && constants.EMPLOYMENT_STATUS_BUSINESS.includes(stepData.employmentStatus) && stepData.employmentStatus !== 'F'"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'business'"
      :validated="formObserver.validated && observer.failed"
      v-bind="observer"
    >
      <form-row
        :label="label"
        :help-text="!isAdditional ? 'If your exact business or industry isn\'t in the list, don\'t worry - please select the closest match.' : 'If their exact business or industry isn\'t in the list, don\'t worry - please select the closest match.'"
        :error="formObserver.validated && observer.failed"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_business-list`"
          name="Business"
          :rules="validationRules || defaultValidationRules"
        >
          <qz-autocomplete
            v-model="businessModel"
            :data-test="fieldTrackerId"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select industry', isMobile)"
            :items="businessSearchItems"
            :errors="errors"
            :update-search="onBusinessSearch"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-business',
  extends: QuestionBase,
  data () {
    return {
      fields: ['businessList', 'businessKey'],
      businessSearchItems: [],
    };
  },
  created () {
    const { businessList, businessKey } = this.stepData;

    if (businessList && businessKey) {
      this.businessSearchItems.push({
        value: businessList,
        text: businessKey,
      });
    }

    this.$watch('stepData.employmentStatus', (val, prevVal) => {
      if (val !== null && prevVal !== null) {
        this.businessSearchItems = [];

        this.stepData.businessList = null;
        this.stepData.businessKey = null;
      }
    });
  },
  computed: {
    label () {
      return this.isAdditional
        ? (this.titleAdditional || this.title || 'Which industry do they work in?')
        : (this.title || 'Which industry do you work in?');
    },
    businessModel: {
      get () {
        return this.questionData.businessList;
      },
      set ({ value, text }) {
        this.questionData.businessList = value;
        this.questionData.businessKey = text;
      },
    },
    defaultValidationRules () {
      const isEmploymentStatusBusiness = this.constants.EMPLOYMENT_STATUS_BUSINESS.includes(this.stepData.employmentStatus);
      return isEmploymentStatusBusiness ? { businessType: { isAdditional: this.isAdditional } } : '';
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.businessList);
    },
  },
  methods: {
    async onBusinessSearch (value) {
      if (!value) return;

      try {
        const response = await this.$api.getBusinesses(value);
        if (response.status === 'success') {
          this.businessSearchItems = response.data.map(item => ({
            value: item.id,
            text: item.name,
          }));
        }
      } catch (error) {
        this.$emit('toast', {
          type: 'error',
          errors: error.toString(),
        });
      }
    },
  },
};
</script>
